import Mention from '@tiptap/extension-mention';

import suggestion from './suggestion';

const MentionExtension = ({ fetchMentions }) =>
	Mention.configure({
		HTMLAttributes: {
			class: 'mention'
		},
		suggestion: {
			...suggestion,
			allowSpaces: true,
			items: ({ query }) => fetchMentions(query)
		}
	});

export default MentionExtension;
